// Widget Factories and Configuration
export { Widgets } from './widgets.factory';
export type {
  BadgeSingleColorWidgetConfig,
  BadgeMultiColorWidgetConfig,
  StarsWidgetConfig,
  ProgressBarWidgetConfig,
  LinkWidgetConfig,
  BooleanCheckWidgetConfig,
  BooleanYesNoWidgetConfig,
  BadgeColor,
} from './widgets.factory';

// Widget Components
export { BadgeSingleColorWidgetComponent } from './badge-single-color/badge-single-color-widget.component';

export { BadgeMultiColorWidgetComponent } from './badge-multi-color/badge-multi-color-widget.component';

export { LinkWidgetComponent } from './link/link-widget.component';

export { ProgressBarWidgetComponent } from './progress-bar/progress-bar-widget.component';

export { StarsWidgetComponent } from './stars/stars-widget.component';

export { BooleanCheckWidgetComponent } from './boolean-check/boolean-check-widget.component';

export { BooleanYesNoWidgetComponent } from './boolean-yes-no/boolean-yes-no-widget.component';
